module.exports = __webpack_public_path__ + "img/318.ecdd0def.png";